export default "__VITE_ASSET__xlgv3vG2__"